import script from "./traffic-status-list.vue?vue&type=script&setup=true&lang=ts"
export * from "./traffic-status-list.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__